import getQuickDepositState from './quickDepositState';
import { findMatchedIframe, matchSrc, matchId, matchClass, matchAny, matchAttr } from './utils';

const registrationMatcher = matchAny<HTMLIFrameElement>([
  matchSrc(/https?:\/\/auth.williamhill.*\.com\/rsp/),
  matchAttr('name', 'cp-registration-frame'),
  matchAttr('name', 'registration-frame'),
  matchClass('cp-reg-iframe'),
  matchId('cp-reg-modal-iframe'),
  matchClass('cp-reg-modal__iframe'),
]);

const depositMatcher = matchAny<HTMLIFrameElement>([
  matchClass('mfp-iframe'),
  matchClass('deposit-modal__iframe'),
  matchSrc(/\/deposit\.html/),
  matchAttr('data-test-id', '@sitebase/standard-deposit.frame'),
  matchAttr('title', 'deposit-modal'),
]);

const isRegistrationOpen = () => !!findMatchedIframe(registrationMatcher);

const isDepositOpen = () => !!findMatchedIframe(depositMatcher);

export default () => !getQuickDepositState().isOpen && !isDepositOpen() && !isRegistrationOpen();
